(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .factory('UserService', UserService);

    UserService.$inject = ['User', '$q', '_'];

    /* @ngInject */
    function UserService(User, $q, _) {
        var user;
        var defaultAvatar = 'http://www.garnasport.ru/img/default-avatar.jpg';

        var service = {
            setUser: setUser,
            getUser: getUser,
            hasUser: hasUser,
            isClient: isClient,
            isManager: isManager,
            isAdmin: isAdmin,

            loadUser: loadUser,
            getClients: getClients,
            getManagers: getManagers,
            getName: getName,
            getAvatar: getAvatar
        };

        return service;

        function setUser(_user) {
            user = _user;
        }

        function getUser() {
            return user;
        }

        function hasUser() {
            return angular.isDefined(user) && angular.isDefined(user.id);
        }

        function isClient(_user) {
            if(angular.isDefined(_user)) {
                return _.get(_user, 'role', false) == 1;
            }
            return _.get(user, 'role', false) == 1;
        }

        function isManager(_user) {
            if(angular.isDefined(_user)) {
                return _.get(_user, 'role', false) == 2;
            }
            return _.get(user, 'role', false) == 2;
        }

        function isAdmin(_user) {
            if(angular.isDefined(_user)) {
                return _.get(_user, 'role', false) == 3;
            }
            return _.get(user, 'role', false) == 3;
        }

        function loadUser(id) {
            return User.get({userId: id})
                .$promise
                .then(function(resp) {
                    setUser(resp.user)
                    return resp
                }, function(e) {
                    return $q.reject(e)
                })
        }

        function getClients(params) {
            if(!_.isObject(params)) {
                params = {};
            }
            params.role = 1;
            return User.get(params)
                .$promise
                .then(function(response) {
                    return _processingUsers(response.object);
                }, function(e) {
                    return $q.reject(e);
                });
        }

        function getManagers() {
            return User.get({role: 2})
                .$promise
                .then(function(response) {
                    return _processingUsers(response.object);
                }, function(e) {
                    return $q.reject(e);
                });
        }

        function getName(user) {
            var name = user.last_name;
            if (user.first_name != '' && user.first_name != null) {
                name += ' ' + user.first_name;
            }
            if (user.middle_name != '' && !_.isNull(user.middle_name)) {
                name += ' ' + user.middle_name;
            }
            return name
        }

        function getAvatar(user) {
            var photo =  _.get(user, 'photo_link', '');
            return (photo != '' && photo != null) ? photo : defaultAvatar;
        }

        function _processingUsers(users) {
            _.forEach(users, function(user) {
                user.name = getName(user);
                user.avatar = getAvatar(user);
            });
            return users;
        }
    }

})();

